import { planCompareRows } from "@/mocks/plansPage";
import type { Plan } from "@/types";

type CellValue = string | boolean;

function Cell({ value }: { value: CellValue }) {
  if (value === true) {
    return <i className="ri-check-line text-lg text-secondary-600"></i>;
  }
  if (value === false) {
    return <i className="ri-subtract-line text-base text-foreground-300"></i>;
  }
  return <span className="text-sm font-medium text-foreground-800">{value}</span>;
}

interface CompareTableProps {
  /** The three subscription tiers, in Free → Business → Premium order. */
  plans: Plan[];
}

/** Side-by-side comparison of every subscription tier's limits and tools. */
export default function CompareTable({ plans }: CompareTableProps) {
  const tiers: { key: string; label: string; highlight: boolean }[] = [
    { key: "free", label: plans[0]?.name || "Free", highlight: false },
    { key: "business", label: plans[1]?.name || "Business", highlight: true },
    { key: "premium", label: plans[2]?.name || "Premium", highlight: false },
  ];

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse text-left">
          <thead>
            <tr className="bg-background-100">
              <th className="px-6 py-4 font-heading text-sm font-bold text-foreground-950">Feature</th>
              {tiers.map((t) => (
                <th
                  key={t.key}
                  className={`px-6 py-4 text-center font-heading text-sm font-bold ${
                    t.highlight ? "text-primary-700" : "text-foreground-950"
                  }`}
                >
                  {t.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {planCompareRows.map((row, i) => {
              const values = row as unknown as Record<string, CellValue>;
              return (
                <tr key={row.label} className={i % 2 === 0 ? "bg-background-50/60" : "bg-background-50"}>
                  <td className="border-t border-background-200 px-6 py-3.5 text-sm text-foreground-700">{row.label}</td>
                  {tiers.map((t) => (
                    <td
                      key={t.key}
                      className={`border-t border-background-200 px-6 py-3.5 text-center ${
                        t.highlight ? "bg-primary-50/50" : ""
                      }`}
                    >
                      <span className="flex items-center justify-center">
                        <Cell value={values[t.key]} />
                      </span>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}